import { MouseEventHandler, forwardRef } from 'react';
import styles from './ui-sidebar-header.module.scss';
import { UISpacer } from '../ui-spacer';
import { UIAvatar } from '../ui-avatar';
import { UIIcon } from '../ui-icon';

type UISidebarHeaderProps = {
    image: string;
    companyName: string;
    userName: string;
    collapsed?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    onMouseOver?: MouseEventHandler<HTMLButtonElement>;
};

export const UISidebarHeader = forwardRef<
    HTMLButtonElement,
    UISidebarHeaderProps
>((props, ref) => {
    const {
        image,
        companyName,
        userName,
        collapsed = false,
        onClick,
        onMouseOver
    } = props;

    return (
        <button
            ref={ref}
            onClick={onClick}
            onMouseOver={onMouseOver}
            className={styles.container}
        >
            <UIAvatar img={image} alt="avatar" size={36} />
            {!collapsed && (
                <>
                    <UISpacer multiplier={1} />
                    <div className={styles.textContainer}>
                        <div className={styles.companyTextContainer}>
                            <div className={styles.company}>{companyName}</div>
                            <UISpacer multiplier={0.5} />
                            <UIIcon
                                name="chevron-down"
                                color="white"
                                size={14}
                            />
                        </div>

                        <UISpacer multiplier={0.2} />
                        <div className={styles.user}>{userName}</div>
                    </div>
                </>
            )}
        </button>
    );
});
